import { Component, Mixins, Prop } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { BCard, BAlert } from 'bootstrap-vue'
import { Spinner } from '@kwixeo/interface-vue'
import StripeMixin from '../../mixins/StripeMixin'
import { PaymentIntent } from '@stripe/stripe-js'

@Component({
  computed: {
    ...mapState('app', ['app']),
  },
  components: {
    BCard, BAlert,
    Spinner
  }
})
export default class PaymentSuccessful extends Mixins(StripeMixin) {
  app!: KwixeoFramework.App

  @Prop({ required: true }) clientSecret!: string
  @Prop({ default: null }) paymentIntent!: PaymentIntent|null

  private loading = false
  private paymentIntentStatus: string|null = null
  private errorMsg: string|null = null

  async mounted (): Promise<void> {
    if (this.paymentIntent) {
      this.paymentIntentStatus = this.paymentIntent.status
      return
    }

    this.loading = true
    await this.initializeStripe()

    if (!this.stripe) {
      this.errorMsg = 'Erreur lors de l\'initialisation'
      this.loading = false
      return
    }

    const { paymentIntent, error } = await this.stripe.retrievePaymentIntent(this.clientSecret);
    if (error) {
      this.errorMsg = error.message ?? 'Une erreur est survenue'
    } else if (paymentIntent) {
      this.paymentIntentStatus = paymentIntent.status
    }
    this.loading = false
  }

  get successMsg (): string {
    switch (this.paymentIntentStatus) {
      case 'succeeded':
        return 'Votre paiement a été accepté.'
      case 'processing':
        return 'Votre paiement est en cours de traitement.'
      case 'requires_payment_method':
        return 'Votre paiement n\'a pas abouti, veuillez réessayer.'
      default:
        return 'Une erreur est survenue.'
    }
  }
}
